var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sc-modal',{attrs:{"active":_vm.isActive,"can-cancel":false}},[_c('sc-modal-card',[_c('template',{attrs:{"slot":"body"},slot:"body"},[_c('section',{staticClass:"modal-content"},[_c('sc-spinner'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.text))])],1)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ead38f9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@intelipost-modules/secure-recon/features/billing/components/billing-loading-modal/BillingLoadingModal.vue
// module id = null
// module chunks = 